/**
 * Questions for The Third Day.
 *
 * Deliberately the ones most people already half-know. This is a walk, not an
 * exam: a wall of hard questions three steps in is a wall, and the point of
 * the mode is the corridor filling with light, not the difficulty.
 *
 * Every one is about Jesus, and every note is the World English Bible text of
 * Matthew, verbatim. Matthew rather than a spread of gospels on purpose — the
 * frame of the walk is the guard at the tomb and the angel's words, both of
 * which are Matthew, so the whole mode speaks with one voice.
 *
 * `right` is always index 0 here; the options are shuffled when a run is
 * dealt, so the order in this file carries no meaning.
 */

export const WALK_QUESTIONS = [
  {
    id: 'born',
    q: 'Where was Jesus born?',
    a: ['Bethlehem', 'Nazareth', 'Jerusalem', 'Capernaum'],
    right: 0,
    ref: 'Matthew 2:1',
    note: '“Now when Jesus was born in Bethlehem of Judea in the days of King Herod…”',
  },
  {
    id: 'baptism',
    q: 'Who baptised Jesus?',
    a: ['John', 'Peter', 'Andrew', 'James'],
    right: 0,
    ref: 'Matthew 3:13',
    note: '“Then Jesus came from Galilee to the Jordan to John, to be baptized by him.”',
  },
  {
    id: 'twelve',
    q: 'How many disciples did Jesus call to himself?',
    a: ['Twelve', 'Seven', 'Ten', 'Forty'],
    right: 0,
    ref: 'Matthew 10:1',
    note: '“He called to himself his twelve disciples, and gave them authority over unclean spirits…”',
  },
  {
    id: 'loaves',
    q: 'What did the disciples have to feed the crowd with?',
    a: ['Five loaves and two fish', 'Two loaves and five fish', 'Seven loaves', 'A basket of bread'],
    right: 0,
    ref: 'Matthew 14:17',
    note: '“They told him, ‘We only have here five loaves and two fish.’”',
  },
  {
    id: 'water',
    q: 'Which disciple walked on the water to Jesus?',
    a: ['Peter', 'John', 'Thomas', 'Philip'],
    right: 0,
    ref: 'Matthew 14:29',
    note: '“Peter stepped down from the boat, and walked on the waters to come to Jesus.”',
  },
  {
    id: 'gethsemane',
    q: 'Where did Jesus pray on the night he was arrested?',
    a: ['Gethsemane', 'Bethany', 'The temple', 'The upper room'],
    right: 0,
    ref: 'Matthew 26:36',
    note: '“Then Jesus came with them to a place called Gethsemane, and said to his disciples, ‘Sit here, while I go there and pray.’”',
  },
  {
    id: 'silver',
    q: 'What was Judas paid to hand Jesus over?',
    a: ['Thirty pieces of silver', 'A field outside the city', 'Ten pieces of gold', 'A place at the table'],
    right: 0,
    ref: 'Matthew 26:15',
    note: '“‘What are you willing to give me, that I should deliver him to you?’ They weighed out for him thirty pieces of silver.”',
  },
  {
    id: 'cross',
    q: 'Who was made to carry the cross?',
    a: ['Simon of Cyrene', 'Simon Peter', 'Joseph of Arimathaea', 'Nicodemus'],
    right: 0,
    ref: 'Matthew 27:32',
    note: '“…they found a man of Cyrene, Simon by name, and they compelled him to go with them, that he might carry his cross.”',
  },
  {
    id: 'sign',
    q: 'What was written above his head on the cross?',
    a: ['This is Jesus, the King of the Jews', 'The Son of God', 'Behold the man', 'King of Israel'],
    right: 0,
    ref: 'Matthew 27:37',
    note: '“They set up over his head the accusation against him written, ‘THIS IS JESUS, THE KING OF THE JEWS.’”',
  },
  {
    id: 'commandment',
    q: 'What did Jesus call the first and great commandment?',
    a: [
      'Love the Lord your God with all your heart',
      'Love your neighbour as yourself',
      'Do to others as you would have them do to you',
      'Honour your father and mother',
    ],
    right: 0,
    ref: 'Matthew 22:37–38',
    note: '“‘You shall love the Lord your God with all your heart, with all your soul, and with all your mind.’ This is the first and great commandment.”',
  },
  {
    id: 'denial',
    q: 'Which disciple denied Jesus three times?',
    a: ['Peter', 'Judas', 'Thomas', 'Matthew'],
    right: 0,
    ref: 'Matthew 26:75',
    note: '“Peter remembered the word which Jesus had said to him, ‘Before the rooster crows, you will deny me three times.’ Then he went out and wept bitterly.”',
  },
  {
    id: 'thirdday',
    q: 'On which day did Jesus say he would be raised?',
    a: ['The third day', 'The seventh day', 'The next day', 'The fortieth day'],
    right: 0,
    ref: 'Matthew 16:21',
    note: '“…that he must go to Jerusalem and suffer many things from the elders, chief priests, and scribes, and be killed, and the third day be raised up.”',
  },
];

/** Steps between the near end of the colonnade and the garden. */
export const WALK_STEPS = 8;
/** Wrong answers you can afford before the way closes. */
export const WALK_LIVES = 3;
